<template>
  <div class="dashboard">
    <div class="secondary-font primary--text">
      Olá <span class="name">{{ nome }}</span>
    </div>
    <v-expand-transition>
      <div class="next-attendence" v-if="nextAttendence" @click="$router.push({ name: 'agendamentos' })">
        <v-icon color="#0F5DFF" size="23">mdi-bell-outline</v-icon>
        <div class="pl-3">
          Seu próximo exame está agendado para o dia {{ nextAttendenceDate }}, às {{ nextAttendenceHour }}. Você poderá
          entrar na sala de atendimento entre {{ minutesBeforeAppointment }} minutos antes e
          {{ minutesAfterAppointment }} minutos após o horário marcado.
        </div>
      </div>
    </v-expand-transition>
    <v-layout align-start justify-start flex>
      <v-row max-width="00" justify-end class="mt-1">
        <v-col v-for="(item, n) in items" :key="n" cols="6" xs="6" sm="6" md="3" lg="3" class="" justify-center>
          <v-card max-width="100%" min-height="170px" justify-center outlined tile
            :class="{ 'card-disabled': item.disabled }" class="dashboard-item"
            @click="!item.disabled ? action(item) : null">
            <div v-if="item.tag && item.disabled" class="tag">
              {{ item.tag }}
            </div>
            <div class="dash-icon">
              <v-icon size="28" :color="item.color">{{ item.icon }}</v-icon>
            </div>
            <div class="dash-name">
              {{ item.title }}
            </div>
          </v-card>
        </v-col>
      </v-row>
    </v-layout>
    <v-layout class="mb-5 mt-10">
      <v-row>
        <v-col :cols="$vuetify.breakpoint.smAndDown ? 12 : 6">
          <BeneficiosList />
        </v-col>
        <v-col cols="6" v-if="$vuetify.breakpoint.mdAndUp">
          <HelpDashboard />
        </v-col>
      </v-row>
    </v-layout>
    <v-layout class="mb-md-8" align-start justify-start flex>
      <v-row>
        <v-col cols="12">
          <UsefulLinks class="mx-3" />
        </v-col>
      </v-row>
    </v-layout>
    <v-layout class="mb-8" v-if="$vuetify.breakpoint.smAndDown">
      <v-col cols="12">
        <HelpDashboard />
      </v-col>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import { subHours, format } from 'date-fns'
import UsefulLinks from './UsefulLinks'
import BeneficiosList from './BeneficiosList'
import HelpDashboard from './HelpDashboard'
import agendamentos from '@/services/agendamentos'

export default {
  name: 'Dashboard',
  components: {
    UsefulLinks,
    BeneficiosList,
    HelpDashboard
  },
  data: () => ({
    tab: 'tab-abertos',
    abertos: [],
    finalizados: [],
    model: 1,
    nextAttendence: null,
    minutesBeforeAppointment: 10,
    minutesAfterAppointment: 30
  }),
  computed: {
    ...mapGetters('user', [
      'nome',
      'agendamentoExpress',
      'empresa',
      'urlLogo',
      'colorTheme',
      'enableTelemedicina',
      'idWorkspace',
      'id'
    ]),
    ...mapState('avaliacaoPsicossocial', ['mapeamentosEmpresa']),
    temMapeamentoAtivo() {
      return !this.mapeamentosEmpresa || this.mapeamentosEmpresa.length > 0
    },
    items() {
      const items = [
        {
          color: 'primary',
          icon: 'mdi-heart-pulse',
          title: 'Meus exames',
          routeName: '/agendamentos',
          show: true
        },
        {
          color: 'primary',
          icon: 'mdi-shield-check',
          title: 'Meus EPI\'s',
          routeName: '/entregas-epi',
          show: true
        },
        {
          color: 'primary',
          icon: 'mdi-file-document-multiple-outline',
          title: 'Meus atestados',
          routeName: 'atestado',
          show: this.idWorkspace === 1
        },
        {
          color: 'primary',
          icon: 'mdi-head-heart-outline',
          title: 'Mapeamento Psicossocial',
          disabled: !this.temMapeamentoAtivo,
          psicossocial: true,
          show: true
        },
        {
          color: 'primary',
          icon: 'mdi-emoticon',
          title: 'Saúde mental',
          msg: 'Inativo',
          routeName: '/saude-mental',
          disabled: false,
          show: this.id === 63063
        },
        // {
        //   color: 'primary',
        //   icon: 'mdi-cellphone-link',
        //   title: 'Ambulatório digital',
        //   routeName: 'ambulatorio-digital',
        //   disabled: true,
        //   tag: 'Em breve',
        //   show: this.idWorkspace === 1
        // },
        {
          color: 'primary',
          icon: 'mdi-google-circles-extended',
          title: 'Rede de benefícios',
          msg: 'Ativo',
          routeName: '/rede-beneficios',
          disabled: true,
          tag: 'Em breve',
          show: true
        }
      ]

      return items.filter(row => row.show)
    },
    nextAttendenceDate() {
      const date = new Date(this.nextAttendence.horario_inicio)
      const offsetMinutes = date.getTimezoneOffset()
      const offsetHours = offsetMinutes / 60
      // Subtrai as horas do offset para obter o horário local
      const localDate = subHours(date, offsetHours)

      return format(localDate, 'dd/MM/yyyy')
    },
    nextAttendenceHour() {
      const date = new Date(this.nextAttendence.horario_inicio)
      const offsetMinutes = date.getTimezoneOffset()
      const offsetHours = offsetMinutes / 60
      // Subtrai as horas do offset para obter o horário local
      const localDate = subHours(date, offsetHours)

      return format(localDate, 'HH:mm')
    }
  },
  methods: {
    ...mapActions('avaliacaoPsicossocial', ['fetchMapeamentosEmpresa']),
    action(item) {
      if (item.psicossocial) {
        return this.$router.push('/psicossocial')
      } else if (item.redirectTo) {
        window.open(item.redirectTo, '_blank')
      } else if (item.routeName && this.$route.path !== item.routeName) {
        return this.$router.push(item.routeName)
      }
    },
    async getAgendamentos() {
      try {
        const { data } = await agendamentos.buscaAgendamentosAbertos()
        this.nextAttendence = data
      } catch (error) {
        this.$showErrorMessage(error.response.data.message)
      }
    },
    applyThemeColor(color) {
      this.$vuetify.theme.themes.light.primary = color
    }
  },
  created() {
    const currentColor = this.colorTheme
    this.applyThemeColor(currentColor)
  },
  beforeMount() {
    this.items[0].disabled = this.agendamentoExpress
  },
  mounted() {
    this.getAgendamentos()
    this.fetchMapeamentosEmpresa()
  }
}
</script>

<style scoped>
.dashboard {
  padding: 24px 24px 8px 24px;
  background-color: #f7f7f7;
}

.name {
  font-weight: 900;
}

.dashboard-item {
  border: none !important;
  border-radius: 10px !important;
  padding: 10px;
  color: #9f9d9d;
  font-weight: 500;
}

.card-disabled {
  background-color: #eaeaea;
  cursor: default;
}

.next-attendence {
  display: flex;
  flex-direction: row;
  border-radius: 10px;
  background-color: #e7e9fc;
  align-items: center;
  color: #3083f0;
  padding: 10px;
  font-size: 0.8rem;
  font-weight: 500;
  margin-top: 10px;
  cursor: pointer;
}

.dashboard-effect_bg::before {
  content: '';
  position: absolute;
  height: 12em;
  width: 100%;
  top: 0;
  background: blue;
}

.dash-icon {
  position: relative;
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: flex-start;
  justify-items: flex-start;
  background-color: #f7f7f7;
  border-radius: 50% !important;
  margin-top: 10px;
}

.dash-icon::before {
  content: '';
  position: absolute;
  height: 60px;
  width: 60px;
  top: 50%;
  transform: translate(0, -50%);
  border-radius: 50%;
  background: transparent;
  z-index: 1;
}

.dash-icon .v-icon {
  font-size: 36px;
  align-items: center;
  display: flex;
  flex: auto;
}

.dash-name {
  margin-left: 12px;
  margin-top: 12px;
  overflow-wrap: normal;
  word-break: normal;
}

.tag {
  background-color: #28a038;
  color: #fff;
  max-width: 40%;
  border-radius: 15px;
  font-size: 0.7rem;
  text-align: center;
}

.tag {
  font-size: 0.7rem;
  background-color: #28a038;
  color: #fff;
  border-radius: 10px;
  text-align: center;
  width: 40%;
}

.card-disabled {
  cursor: default;
  background-color: #dfe4e9 !important;
  border-color: #dfe4e9 !important;
}

@media only screen and (min-width: 960px) {
  .dashboard {
    padding-right: 100px;
    padding-left: 100px;
    margin-top: 20px;
  }

  .next-attendence {
    font-size: 1rem !important;
    height: 55px;
  }
}
</style>
